import { Props } from "./ModalLabel.Parts";

/**
 *
 * A simple component to render the title of a non-radix modal. It accepts an `id`
 * prop which is used to link the title to a modal dialog for accessibility purposes.
 * Intended to be rendered inside of a text component (e.g. `Heading`) for proper styling.
 *
 * When using a radix modal, please use the `Dialog.Title` component from `@radix-ui/react-dialog`
 * instead, as it will automatically link the title to the dialog for accessibility.
 */
export const ModalLabel = ({ id = "modal-title", children }: Props) => (
  <div id={id}>{children}</div>
);
